import {Brick, registerBrick} from 'olympe';

/**
 * FilterCostCenter
 */
export default class FilterCostCenter extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} costCenters
     * @param {function(string)} setFilteredCostCenters
     */
    update($, [costCenters], [setFilteredCostCenters]) {
        const convertStringToDate = (string) => {
            if (string.indexOf('-') !== -1) {
                const parts = string.split('-');
                return new Date(parts[0], parts[1] - 1, parts[2]);
            }

            const year = string.substring(0, 4);
            const month = string.substring(4, 6);
            const day = string.substring(6, 8);
            return new Date(year, month - 1, day);
        };

        const currentDate = new Date();

        const costCentersArray = JSON.parse(costCenters);

        const filteredCostCenters = costCentersArray.filter((costCenter) => {
            const fromDate = convertStringToDate(costCenter.datab);
            const toDate = convertStringToDate(costCenter.datbi);
            return fromDate <= currentDate && currentDate <= toDate;
        });

        setFilteredCostCenters(JSON.stringify(filteredCostCenters));
    }
}

registerBrick('018dc5b88c7492cf82a3', FilterCostCenter);
